<div *ngIf="currentUser.role === 'ROLE_EMPLOYEE'">
  <div class="p-col-12 p-grid p-jc-center">
    <div class="home-worklog-form form-container p-card">
      <h2 i18n="home header|Home header@@home-header">
        Welcome {{ currentUser.firstName }} {{ currentUser.lastName }}, log time.
      </h2>
      <form *ngIf="worklogForm" class="p-fluid p-formgroup-inline" [formGroup]="worklogForm" (ngSubmit)="onSubmit()">
        <div class="p-field">
          <p-inputNumber
            mode="decimal"
            min="0"
            formControlName="hours"
            [maxFractionDigits]="1"
            [minFractionDigits]="1"
            locale="pl-PL"
            placeholder="Hours"
            i18n-placeholder="number of hours field | Number of hours field@@worklog-hours-field"
            (onBlur)="roundToHalves($event)"
          ></p-inputNumber>
        </div>
        <div class="p-field">
          <p-calendar
            formControlName="date"
            styleClass="monthpicker"
            dateFormat="dd MM yy"
            [showIcon]="true"
            [yearRange]="thisYear"
            [readonlyInput]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [showOtherMonths]="false"
            inputId="monthpicker"
            i18n-placeholder="date field | date field@@worklog-date-field"
            placeholder="date"
            [firstDayOfWeek]="1"
          ></p-calendar>
        </div>
        <div class="p-field">
          <p-dropdown
            i18n-placeholder="positions picker placeholder|Positions picker placeholder@@worklog-position-field"
            placeholder="Position"
            [options]="positions"
            optionLabel="name"
            dataKey="id"
            [filter]="false"
            formControlName="position"
          ></p-dropdown>
        </div>
        <div class="p-field">
          <p-dropdown
            i18n-placeholder="workplace picker placeholder|Workplace picker placeholder@@worklog-workplace-field"
            placeholder="Workplace"
            [options]="workplaces"
            optionLabel="name"
            dataKey="id"
            [filter]="false"
            formControlName="workplace"
          ></p-dropdown>
        </div>
        <div class="p-fluid">
          <button
            [disabled]="requestPending"
            type="submit"
            pButton
            i18n-label="save user profile button|Save user profile button@@save-worklog-button"
            label="Save"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
<h2 *ngIf="currentUser.role === 'ROLE_ADMIN'" i18n="admin home header|admin Home header@@admin-home-header">
  Welcome {{ currentUser.firstName }} {{ currentUser.lastName }}
</h2>
<p-dialog
  header="Oświadczenie w sprawie wyrażenia zgody na przetwarzanie danych osobowych"
  [(visible)]="displayGdprModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <p class="p-mb-3">
    Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE)
    2016/2017 z dnia 27 kwietnia 2016 r. (ogólne rozporządzenie o ochronie danych) oraz ustawą z dnia 10 maja 2018 r. o
    ochronie danych osobowych (Dz. U. z 2018r., poz. 1000 z późn. zm.) przez Hevelia Swim & Spa Spółka z ograniczoną
    odpowiedzialnością, z siedzibą przy ul. Jana Kilińskiego 7, 80-452 Gdańsk, KRS: 0001151956, NIP: 9571183719,
    REGON: 540748460 (administratora danych osobowych) i przyjmuję do wiadomości, że celem przetwarzania podanych przeze
    mnie danych osobowych jest dokonanie wszelkich czynności składających się na proces realizacji umowy.
  </p>
  <p class="p-mb-3">
    Oświadczam również, że mam świadomość, iż podanie ww. danych osobowych jest dobrowolne, oraz że zgoda może być
    cofnięta w każdym czasie, jednak brak ich podania lub brak wyrażenia zgody na ich przetwarzanie lub cofnięcie zgody
    skutkują brakiem możliwości realizacji umowy.
  </p>
  <p class="p-m-0">
    Zapoznałam/em* się z treścią klauzuli informacyjnej umieszczonej na stronie https://hevelia.spa, w tym z informacją o celu
    i sposobach przetwarzania danych osobowych oraz prawie dostępu do treści swoich danych i prawie ich poprawiania.
  </p>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="acceptGdpr()" label="Wyrażam zgodę" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>
